module.exports = __webpack_public_path__ + "static/media/Hayley-Green.769a66dc.jpg";